import { useState } from "react"
import DREColumnsContent from "./DREColumnsContent"
import DRESubgroup from "./DRESubgroup"
import { getBackgroundColor } from "./DREHelper"

/* eslint-disable */
const DREGroup = ({ group }) => {
  const [collapsed, setCollapsed] = useState(true)
  const fullName = `${group.classification} - ${group.name}`

  return (
    <div>
      <DREColumnsContent
        name={fullName}
        values={group.values}
        total={group.total}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        backgroundColor={getBackgroundColor(group)}
      />

      {!collapsed && group.children?.map((child) => (
        <DRESubgroup key={child.classification} subgroup={child} />
      ))}
    </div>
  )
}


export default DREGroup